import React from "react";

import Title from "../Text/Title/Title";
import Paragraph from "../Text/Paragraph/Paragraph";
import { StyledPage, Highlight, A } from "../../Styled-Components/styles";
import logo from "../../images/logo.svg";

const Contact = () => {
  return (
    <StyledPage>
      <Title title="Contact" />

      <Paragraph>
        It would be <Highlight>great to hear from you.</Highlight>
      </Paragraph>
      <Paragraph>
        If you have any feedback or want to get in touch, you can reach me at{" "}
        <A href="mailto:reforest-the-world@protonmail.com">reforest-the-world@protonmail.com</A>{" "}
      </Paragraph>
      <img
        style={{ padding: "5vh 0", width: "30%", margin: "0 auto", display: "block" }}
        src={logo}
      />
    </StyledPage>
  );
};

export default Contact;
